import React, { useEffect, useState } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import { Element, scroller } from "react-scroll";

import Error from "../conferencias/Error";
import Home from "../conferencias/Home";
import { AuthContext } from "../../utils/AuthContext";
import Header from "./Header";
import Footer from "./Footer";

import "../../assets/css/general.css";

export const Master = () => {
  const location = useLocation();
  const [idioma, setIdioma] = useState("es");

  const secciones_auth = [
    { componente: <Home idioma={idioma} />, url: "/" },
    {componente:Error, utl:'/*'}
  ];
  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  useEffect(() => {
    if (location.hash === "") {
      scroller.scrollTo("header");
    } else {
      scroller.scrollTo(location.hash);
    }
  });

  useEffect(() => {
    sleep(1000).then(() => {
      if (location.hash === "") {
        scroller.scrollTo("header");
      } else {
        scroller.scrollTo(location.hash);
      }
    });
  }, []);

  let visualizar_secciones_auth = secciones_auth.map((seccion) => {
    if (
      seccion.url === "/registro" ||
      seccion.url === "/registro"
    ) {
      return (
        <Route path={seccion.url} exact>
          {seccion.componente}
        </Route>
      );
    }
    return (
      <Route
        path={seccion.url}
        exact
        render={(props) => {
          return seccion.componente;
        }}
      />
    );
  });


  return (
    <AuthContext>
      <Element name="header"></Element>
      <Header />
      <Switch>
        {visualizar_secciones_auth}

        <Route path="/*" exact component={Error} idioma={idioma} />
      </Switch>
      <Footer />
    </AuthContext>
  );
};
